// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * This is the base resource type for everything.
 */
export type IResource = {
  /**
   * Resource Type Name
   */
  resourceType: string;
  /**
   * The only time that a resource does not have an id is when it is being submitted to the server using a create operation.
   */
  id?: string|undefined;
  _id?: fhir.IFhirElement|undefined;
  /**
   * Asserting this rule set restricts the content to be only understood by a limited set of trading partners. This inherently limits the usefulness of the data in the long term. However, the existing health eco-system is highly fractured, and not yet ready to define, collect, and exchange data in a generally computable sense. Wherever possible, implementers and/or specification writers should avoid using this element. Often, when used, the URL is a reference to an implementation guide that defines these special rules as part of it's narrative along with other profiles, value sets, etc.
   */
  implicitRules?: string|undefined;
  _implicitRules?: fhir.IFhirElement|undefined;
  /**
   * Language is provided to support indexing and accessibility (typically, services such as text to speech use the language tag). The html language tag in the narrative applies  to the narrative. The language tag on the resource may be used to specify the language of other presentations generated from the data in the resource. Not all the content has to be in the base language. The Resource.language should not be assumed to apply to the narrative automatically. If a language is specified, it should it also be specified on the div element in the html (see rules in HTML5 for information about the relationship between xml:lang and the html lang attribute).
   */
  language?: string|undefined;
  _language?: fhir.IFhirElement|undefined;
  /**
   * The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
   */
  meta?: fhir.IMeta|undefined;
}
/**
 * This is the base resource type for everything.
 */
export class Resource implements fhir.IResource {
  /**
   * Resource Type Name
   */
  public resourceType: string;
  /**
   * The only time that a resource does not have an id is when it is being submitted to the server using a create operation.
   */
  public id?: string|undefined;
  public _id?: fhir.FhirElement|undefined;
  /**
   * Asserting this rule set restricts the content to be only understood by a limited set of trading partners. This inherently limits the usefulness of the data in the long term. However, the existing health eco-system is highly fractured, and not yet ready to define, collect, and exchange data in a generally computable sense. Wherever possible, implementers and/or specification writers should avoid using this element. Often, when used, the URL is a reference to an implementation guide that defines these special rules as part of it's narrative along with other profiles, value sets, etc.
   */
  public implicitRules?: string|undefined;
  public _implicitRules?: fhir.FhirElement|undefined;
  /**
   * Language is provided to support indexing and accessibility (typically, services such as text to speech use the language tag). The html language tag in the narrative applies  to the narrative. The language tag on the resource may be used to specify the language of other presentations generated from the data in the resource. Not all the content has to be in the base language. The Resource.language should not be assumed to apply to the narrative automatically. If a language is specified, it should it also be specified on the div element in the html (see rules in HTML5 for information about the relationship between xml:lang and the html lang attribute).
   */
  public language?: string|undefined;
  public _language?: fhir.FhirElement|undefined;
  /**
   * The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
   */
  public meta?: fhir.Meta|undefined;
  /**
   * Default constructor for Resource - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IResource> = {}) {
    this.resourceType = 'Resource';
    if (source["id"]) { this.id = source.id; }
    if (source["_id"]) { this._id = new fhir.FhirElement(source._id!); }
    if (source["implicitRules"]) { this.implicitRules = source.implicitRules; }
    if (source["_implicitRules"]) { this._implicitRules = new fhir.FhirElement(source._implicitRules!); }
    if (source["language"]) { this.language = source.language; }
    if (source["_language"]) { this._language = new fhir.FhirElement(source._language!); }
    if (source["meta"]) { this.meta = new fhir.Meta(source.meta!); }
  }
  /**
   * Check if the current Resource contains all required elements.
   */
  checkRequiredElements():string[] {
    var missingElements:string[] = [];
    return missingElements;
  }
  /**
   * Factory function to create a Resource from an object that MUST contain all required elements.
   */
  static fromStrict(source:fhir.IResource):Resource {
    var dest:Resource = new Resource(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Resource is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
